import {addDays} from 'date-fns';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {AftersalesPaymentMethod} from '@dms/api/sales';

import {Nullish} from 'shared/web';

const DEFAULT_DUE_DAYS_BANK_TRANSFER = 14;

interface ResolveDueOnPaymentMethodChangeParams {
  method: AftersalesPaymentMethod;
  issueDate: Date;
  invoiceMaturity: number | Nullish;
}

/**
 * Resolves due days and due date when the user deliberately changes the payment method.
 * Bank transfer uses the customer invoice maturity, every other method is payable immediately.
 */
export function resolveDueOnPaymentMethodChange(params: ResolveDueOnPaymentMethodChangeParams) {
  const due = match(params.method)
    .with('BANK_TRANSFER', () => params.invoiceMaturity ?? DEFAULT_DUE_DAYS_BANK_TRANSFER)
    .otherwise(always(0));

  return {due, dueDate: addDays(params.issueDate, due)};
}
